import { render, staticRenderFns } from "./EventPackagesList.vue?vue&type=template&id=528457c4&scoped=true"
import script from "./EventPackagesList.vue?vue&type=script&lang=js"
export * from "./EventPackagesList.vue?vue&type=script&lang=js"
import style0 from "./EventPackagesList.vue?vue&type=style&index=0&id=528457c4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "528457c4",
  null
  
)

export default component.exports